import Popper from "./Popper.vue"
import PopperProxyMixin from "@/components/tooltip/PopperProxyMixin"

export { Popper, PopperProxyMixin }

export default {
    install(Vue) {
        Vue.component("Popper", Popper)
    },
}
